// BootstrapVue on-demand toast'ları (`$bvToast`) çağıran component'e parent'lı
// oluşturuluyor. Sayfa değişince o component destroy olunca, toast'ın portal'a
// taşınmış görünür DOM'u (`.b-toast`) ekranda "orphan" olarak kalıyor: Vue
// instance'ı öldüğü için `$bvToast.hide()` ona ulaşamıyor ve kapatma butonu
// çalışmıyordu. Bu yardımcı, navigasyon tamamlandıktan sonra ekranda kalan tüm
// toast DOM düğümlerini doğrudan kaldırır.

// Not: DOM manipülasyonu proje kurallarında utils/ dizininde 3rd party kütüphane temizliği serbesttir.
export function clearAllToasts() {
  const toastNodes = document.querySelectorAll(".b-toast");
  toastNodes.forEach((node) => {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
